import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes, max } from "date-fns";

/**
 * Calculates the minutes elapsed between reference date and target date.
 * If the target date is in the future, returns 0.
 */
export function calculateMinutesElapsed(targetDate: Date, referenceDate: Date): number {
  return Math.max(differenceInMinutes(referenceDate, targetDate), 0);
}

/**
 * Calculates minutes elapsed from shiftStartDate to the effective reference date.
 * When targetArrivalTime is provided, it is used as an additional lower bound for the reference
 * date, ensuring elapsed time accounts for when the worker is expected to arrive rather than
 * dropping continuously before they've even arrived.
 */
export function getMinutesElapsedWithTargetArrival({
  shiftStartDate,
  baseReferenceDate,
  targetArrivalTime,
}: {
  shiftStartDate: Date;
  baseReferenceDate: Date;
  targetArrivalTime: Date | undefined;
}): number {
  const referenceDate = isDefined(targetArrivalTime)
    ? max([baseReferenceDate, targetArrivalTime])
    : baseReferenceDate;
  return calculateMinutesElapsed(shiftStartDate, referenceDate);
}
